/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';
import type { Smartlist, FindSmartlistParams, SmartlistItem } from 'types';

const find = async (params: FindSmartlistParams): Promise<Smartlist[]> => {
  const endpoint = params.parentId
    ? 'smartlists/find-children-and-unlock-by-user'
    : 'smartlists/find-and-unlock-by-user';
  const response = await callApiEndpoint(endpoint, {
    parentSmartlistId: params.parentId,
    ...(params.pagination || {}),
  });
  // ignoro dati aggiuntivi della risposta e prendo il primo elemento di un array (con un unico elemento)
  const results = response.map(utils.toSmartlist);
  return results;
};

const get = async (id: number): Promise<Smartlist> => {
  const endpoint = 'smartlists/get';
  const response = await callApiEndpoint(endpoint, { smartlistId: id });
  return utils.toSmartlist(response);
};

const findItems = async (id: number): Promise<SmartlistItem[]> => {
  const endpoint = 'smartlists/get-smartlist-items';
  const response = await callApiEndpoint(endpoint, { smartlistId: id });
  return response.map(utils.toSmartlistItem);
};

export default {
  find,
  get,
  items: { find: findItems },
};
